"use strict";
/*
 * This code was generated by
 * ___ _ _ _ _ _    _ ____    ____ ____ _    ____ ____ _  _ ____ ____ ____ ___ __   __
 *  |  | | | | |    | |  | __ |  | |__| | __ | __ |___ |\ | |___ |__/ |__|  | |  | |__/
 *  |  |_|_| | |___ | |__|    |__| |  | |    |__] |___ | \| |___ |  \ |  |  | |__| |  \
 *
 * Twilio - Lookups
 * This is the public Twilio REST API.
 *
 * NOTE: This class is auto generated by OpenAPI Generator.
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryInstance = exports.SmsPumpingRiskInfo = exports.SimSwapInfo = exports.RiskParameters = exports.ReassignedNumberParameters = exports.ReassignedNumberInfo = exports.LookupRequest = exports.LookupBatchResponse = exports.LookupBatchRequest = exports.LineTypeIntelligenceInfo = exports.LineStatusInfo = exports.LastSimSwapInfo = exports.IdentityMatchParameters = exports.IdentityMatchInfo = exports.CallerNameInfo = exports.CallForwardingInfo = void 0;
exports.QueryListInstance = QueryListInstance;
const util_1 = require("util");
const deserialize = require("../../../base/deserialize");
const serialize = require("../../../base/serialize");
class CallForwardingInfo {
}
exports.CallForwardingInfo = CallForwardingInfo;
class CallerNameInfo {
}
exports.CallerNameInfo = CallerNameInfo;
class IdentityMatchInfo {
}
exports.IdentityMatchInfo = IdentityMatchInfo;
class IdentityMatchParameters {
}
exports.IdentityMatchParameters = IdentityMatchParameters;
class LastSimSwapInfo {
}
exports.LastSimSwapInfo = LastSimSwapInfo;
class LineStatusInfo {
}
exports.LineStatusInfo = LineStatusInfo;
class LineTypeIntelligenceInfo {
}
exports.LineTypeIntelligenceInfo = LineTypeIntelligenceInfo;
class LookupBatchRequest {
}
exports.LookupBatchRequest = LookupBatchRequest;
class LookupBatchResponse {
}
exports.LookupBatchResponse = LookupBatchResponse;
class LookupRequest {
}
exports.LookupRequest = LookupRequest;
class ReassignedNumberInfo {
}
exports.ReassignedNumberInfo = ReassignedNumberInfo;
class ReassignedNumberParameters {
}
exports.ReassignedNumberParameters = ReassignedNumberParameters;
class RiskParameters {
}
exports.RiskParameters = RiskParameters;
class SimSwapInfo {
}
exports.SimSwapInfo = SimSwapInfo;
class SmsPumpingRiskInfo {
}
exports.SmsPumpingRiskInfo = SmsPumpingRiskInfo;
function QueryListInstance(version) {
    const instance = {};
    instance._version = version;
    instance._solution = {};
    instance._uri = `/batch/query`;
    instance.create = function create(params, headers, callback) {
        if (params instanceof Function) {
            callback = params;
            params = {};
        }
        else {
            params = params || {};
        }
        let data = {};
        data = params;
        if (headers === null || headers === undefined) {
            headers = {};
        }
        headers["Content-Type"] = "application/json";
        headers["Accept"] = "application/json";
        let operationVersion = version, operationPromise = operationVersion.create({
            uri: instance._uri,
            method: "post",
            data,
            headers,
        });
        operationPromise = operationPromise.then((payload) => new QueryInstance(operationVersion, payload));
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    };
    instance.createWithHttpInfo = function createWithHttpInfo(params, headers, callback) {
        if (params instanceof Function) {
            callback = params;
            params = {};
        }
        else {
            params = params || {};
        }
        let data = {};
        data = params;
        if (headers === null || headers === undefined) {
            headers = {};
        }
        headers["Content-Type"] = "application/json";
        headers["Accept"] = "application/json";
        let operationVersion = version;
        // CREATE, FETCH, UPDATE operations
        let operationPromise = operationVersion
            .createWithResponseInfo({
            uri: instance._uri,
            method: "post",
            data,
            headers,
        })
            .then((response) => ({
            ...response,
            body: new QueryInstance(operationVersion, response.body),
        }));
        operationPromise = instance._version.setPromiseCallback(operationPromise, callback);
        return operationPromise;
    };
    instance.toJSON = function toJSON() {
        return instance._solution;
    };
    instance[util_1.inspect.custom] = function inspectImpl(_depth, options) {
        return (0, util_1.inspect)(instance.toJSON(), options);
    };
    return instance;
}
class QueryInstance {
    constructor(_version, payload) {
        this._version = _version;
        this.phoneNumbers = payload.phone_numbers;
    }
    /**
     * Provide a user-friendly representation
     *
     * @returns Object
     */
    toJSON() {
        return {
            phoneNumbers: this.phoneNumbers,
        };
    }
    [util_1.inspect.custom](_depth, options) {
        return (0, util_1.inspect)(this.toJSON(), options);
    }
}
exports.QueryInstance = QueryInstance;
